module.exports = __webpack_public_path__ + "static/media/carta_3.5cf53f2b.jpg";